Monitoring.Views.SocialContents ||= {}

class Monitoring.Views.SocialContents.SocialContentLinkedInMediaView extends Backbone.View
  template: JST["backbone/templates/monitoring/social_contents_v2/social_content_linkedin_media"]
  className: 'sc-media sc-media--linkedin'

  initialize: (options = {}) ->
    @link = options.link

  render: ->
    @$el.html @template {@link}
    @
